import React, { Component }  from 'react';
import axios from 'axios';
import { Alert, Col, Row } from 'reactstrap';
import { InputGroup, Button, FormControl, Spinner } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { isEmail, isEmpty } from 'validator';

export default class Mail extends Component {

	constructor(props) {
		super(props);
		this.state = {
			hiddenPass: true,
			passType: 'password',
			email_to: '',
			errorForm: false,
			errorFormMessage: '',
			successForm: false,
			successFormMessage: '',
			loadingSendMail: false,
			disableButtonSendMail: false
		}
	}

	testSendMail = () => {
 		if ( this.validate() ) {

 			this.setState({
 				loadingSendMail: true,
				disableButtonSendMail: true
 			});

			let dataAuth = {
				username: process.env.REACT_APP_CLIENT_ID,
				password: process.env.REACT_APP_CLIENT_PASSWD,
				token: process.env.REACT_APP_KEY,
			};
			let email_to = { email_to: this.state.email_to }
			let config = {
			  	headers: {
					'Content-Type': 'application/json',
					'Authorization' : this.props.token,
					'dataAgency' : JSON.stringify(dataAuth)
				},
				params: { ...this.props.mail, ...email_to }
			}

			axios.get( process.env.REACT_APP_API_URL + '/api/admin/config-system/send-mail-test', config)
			.then( (ref) => {
				// console.log(ref.data);
				if ( ref.data.error === 0 ) {
					this.setState({
						successForm: true,
						successFormMessage: ref.data.message,
						loadingSendMail: false,
						disableButtonSendMail: false
					});
				} else {
					if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
						this.props.logOut();
					} else {
						this.setState({
							errorForm: true,
							errorFormMessage: ref.data.message,
							loadingSendMail: false,
							disableButtonSendMail: false
						})
					}
				}
			})
			.catch( (error) => {
				console.log(error);
				this.setState({
					loadingSendMail: false,
					disableButtonSendMail: false
				});
				this.setState({
					errorForm: true,
					errorFormMessage: 'Gửi dữ liệu thất bại',
				})
			})
 		}
	}

	validate = () => {
		if ( isEmpty(this.props.mail.smtp_email)) {
            this.setState({
                errorForm: true,
                errorFormMessage: "Email không được để trống"
            })
            return false;
        }
        else if ( !isEmail(this.props.mail.smtp_email)) {
            this.setState({
                errorForm: true,
                errorFormMessage: "Sai định dạng email"
            })
            return false;
        }  
        else if ( isEmpty(this.props.mail.smtp_password)) {
            this.setState({
                errorForm: true,
                errorFormMessage: "Mật khẩu không được để trống"
            })
            return false;
        }    
        else if ( isEmpty(this.props.mail.smtp_drive)) {
            this.setState({
                errorForm: true,
                errorFormMessage: "SMTP Driver không được để trống"
            })
            return false;
        }      
        else if ( isEmpty(this.props.mail.smtp_port)) {
            this.setState({
                errorForm: true,
                errorFormMessage: "SMTP Port không được để trống"
            })
            return false;
        }
        else if ( isEmpty(this.props.mail.smtp_host)) {
            this.setState({
                errorForm: true,
                errorFormMessage: "SMTP Host không được để trống"
            })
            return false;
        }
        else if ( isEmpty(this.state.email_to) ) {
            this.setState({
                errorForm: true,
                errorFormMessage: "Chưa nhập email để gửi"
            })
            return false;
        } 
        else if ( !isEmail(this.state.email_to) ) {
            this.setState({
                errorForm: true,
                errorFormMessage: "Sai định dạng email"
            })
            return false;
        } 
        return true;
	}
	

	render() {
		return (
			<>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="smtp_email">Email</label>
					</Col>
					<Col md={10}>
					 	<input type="email" value={ this.props.mail.smtp_email } onChange={this.props.onChangeValue} className="form-control" id="smtp_email" name="smtp_email" placeholder="Email" />
					</Col>
				</Row>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="smtp_password">Mật khẩu</label>
					</Col>
					<Col md={10}>
						<InputGroup className="mb-3">
						    <FormControl
						    	type={this.state.passType} 
						    	value={ this.props.mail.smtp_password } 
						    	onChange={this.props.onChangeValue}
						    	id="smtp_password" 
						    	name="smtp_password"
						      	placeholder="Mật khẩu"
						      	aria-label="Mật khẩu"
						      	aria-describedby="basic-addon2"
						      	autoComplete="false"
						    />
						    <Button variant="outline-primary" id="button-addon2" onClick={ () => { this.setState({ hiddenPass: this.state.hiddenPass ? false : true, passType: this.state.hiddenPass ? 'text' : 'password' }) } }>
						    	{
						    		this.state.hiddenPass ? <FaEye /> : <FaEyeSlash />
						    	}
						    </Button>
						</InputGroup>
					 	<div className="text-danger">
				        	<b>⁕Lưu ý:</b> Nếu dùng tài khoản gmail thì nên sử dụng mật khẩu ứng dụng của tài khoản email
				      	</div>
					</Col>
				</Row>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="smtp_drive">SMTP Driver</label>
					</Col>
					<Col md={10}>
					 	<input type="text" value={ this.props.mail.smtp_drive } onChange={this.props.onChangeValue} className="form-control" id="smtp_drive" name="smtp_drive" placeholder="SMTP DRIVER" />
					</Col>
				</Row>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="smtp_host">SMTP Host</label>
					</Col>
					<Col md={10}>
					 	<input type="text" value={ this.props.mail.smtp_host } onChange={this.props.onChangeValue} className="form-control" id="smtp_host" name="smtp_host" placeholder="SMTP Host" />
					</Col>
				</Row>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="smtp_port">SMTP Port</label>
					</Col>
					<Col md={10}>
					 	<input type="text" value={ this.props.mail.smtp_port } onChange={this.props.onChangeValue} className="form-control" id="smtp_port" name="smtp_port" placeholder="SMTP Port" />
					</Col>
				</Row>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="smtp_ssl">Bảo mật SMTP</label>
					</Col>
					<Col md={10}>
						<select name="smtp_ssl" value={this.props.mail.smtp_ssl} onChange={this.props.onChangeValue} id="smtpSSLType" className="form-control" >
                            <option value="">None</option>
			                <option value="ssl">SSL</option>
			                <option value="tsl">TSL</option>
	                    </select>
					</Col>
				</Row>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="sender_name">Tên người gửi</label>
					</Col>
					<Col md={10}>
					 	<input type="text" value={ this.props.mail.sender_name } onChange={this.props.onChangeValue} className="form-control" id="sender_name" name="sender_name" placeholder="Tên người gửi" />
					</Col>
				</Row>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="sender_email">Email gửi</label>
					</Col>
					<Col md={10}>
					 	<input type="text" value={ this.props.mail.sender_email } onChange={this.props.onChangeValue} className="form-control" id="sender_email" name="sender_email" placeholder="Email gửi" />
					</Col>
				</Row>
				<Row className="form-group">
					<Col md={2} className="col-form-label">
						<label htmlFor="setting_email_signature">Chữ ký Email</label>
					</Col>
					<Col md={10}>
						{
					 		this.props.mail.email_signature ? (
					 			<div className="text-success">
							        Đã thiết lập chữ ký email
						      	</div>
				 			) : (
				 				<div className="text-danger">
						        	Chưa thiết lập chữ ký email
						      	</div>
				 			)
						}
						<>
					        <textarea name="email_signature" value={ this.props.mail.email_signature }  onChange={this.props.onChangeValue} id="email_signature" className="d-none" />
					        <button type="button" id="setting_email_signature" className="btn btn-default btn-sm" onClick={this.props.showModal}>
					          	Chỉnh sửa chữ ký
					        </button>
				      	</>
					</Col>
				</Row>
				<Row>
					<Col id="send-mail-test">
						{
							this.state.errorForm ? (
								<Col className="px-0">
									<Alert color="danger">
	                                    { this.state.errorFormMessage }
	                                </Alert>
								</Col>
							) : (
								<></>
							)
						}
						{
							this.state.successForm ? (
								<Col className="px-0">
									<Alert color="success">
	                                    { this.state.successFormMessage }
	                                </Alert>
								</Col>
							) : (
								<></>
							)
						}
						<h5>Kiểm tra liên kết mail</h5>
						<Row className="form-group mb-0">
							<Col md={2} className="col-form-label">
								<label htmlFor="email_to">Gửi đến email</label>
							</Col>
							<Col md={10}>
							 	<input type="text" className="form-control" id="email_to" name="email_to" onChange={ (e) => { this.setState({ email_to: e.target.value }) } } placeholder="Gửi đến email" />
							</Col>
							<Col className="mb-0">
								<Button variant="primary" 
									size="sm" 
									disabled={this.state.disableButtonSendMail}
									onClick={ this.testSendMail }
								>
									{
										this.state.loadingSendMail ? (
											<Spinner
										      	as="span"
										      	animation="grow"
										      	size="sm"
										      	role="status"
										      	aria-hidden="true"
										      	
										    />
										) : (
											<></>
										)
									}
								    Kiểm tra
							  	</Button>
							</Col>
						</Row>
					</Col>
				</Row>

			</>
		)
	}
}